module.exports = __webpack_public_path__ + "static/media/news-5.e8d57ce1.svg";